/**
 * announcementsApi.ts - v2026.06.158
 * News popup à la connexion (in-app announcements).
 */
import { apiFetch } from './apiClient';

export interface ClientAnnouncement {
  id:            string;
  slug:          string;
  title:         string;
  body:          string;
  summary?:      string;
  category?:     string;
  coverImageUrl?: string | null;
  priority:      number;
  dismissable:   boolean;
  publishedAt?:  string | null;
  createdAt?:    string;
}

export interface AnnouncementsResponse {
  items:  ClientAnnouncement[];
  total:  number;
  locale: string;
}

export const announcementsApi = {
  list: () => apiFetch<AnnouncementsResponse>('/clients/announcements'),
  dismiss: (newsId: string) =>
    apiFetch<{ dismissed: boolean; newsId: string }>(
      `/clients/announcements/${encodeURIComponent(newsId)}/dismiss`,
      { method: 'POST' }
    ),
};
